import Component from '@glimmer/component'
import { service } from '@ember/service'
import type DateFilterService from 'teacher-ui-client/services/date-filter'
import type RouterService from '@ember/routing/router-service'
import { PeriodDatePicker } from 'teacher-ui-client/components/dates/period-date-picker'
import { type NormalizedInterval } from 'date-fns'

interface Signature {
  Args: {
    disabled?: boolean
  }
  Element: HTMLElement
}

export class ReportingPeriodSelect extends Component<Signature> {
  @service dateFilter!: DateFilterService

  @service router!: RouterService

  onPeriodSelected = ({ start, end }: NormalizedInterval) => {
    const dateRange = this.dateFilter.toDateRange({ start, end })
    void this.router.transitionTo({ queryParams: { dateRange } })
  }

  <template>
    <PeriodDatePicker
      data-test-period-select
      class="w-full max-w-84"
      @period={{this.dateFilter.period}}
      @onPeriodSelected={{this.onPeriodSelected}}
      @isDisabled={{@disabled}}
      ...attributes
    />
  </template>
}

export default ReportingPeriodSelect
